import * as Hooks from 'preact/hooks';
import { useDispatch } from 'react-redux';
import { useSelector } from '../redux';
import * as Logging from '../../../store/actions/logging';
import * as Selectors from '../../../store/selectors';

export const useGetLogo = () => {
    const dispatch = useDispatch();
    const tenantIdentifier = useSelector(Selectors.Core.tenantIdentifier);
    const [logo, setLogo] = Hooks.useState<string | null>(null);

    Hooks.useEffect(() => {
        if (!tenantIdentifier) return;
        const setter = async () => {
            switch (tenantIdentifier) {
                case 'moda':
                case 'article':
                    setLogo(`assets/${tenantIdentifier}/logo.svg`);
                    break;
                default:
                    dispatch(
                        Logging.logWarning('no logo for tenant found, using fixtuur default', {
                            tenantIdentifier,
                        }),
                    );
                    setLogo(`assets/fixtuur-logo.svg`);
            }
        };

        setter();
    }, [tenantIdentifier]);

    return logo;
};
